// extracted by mini-css-extract-plugin
export var date = "Award__date-I8q5i";
export var figure = "Award__figure-9oJIv";
export var footer = "Award__footer-M3fTp";
export var text = "Award__text-Evh3C";
export var toolbar = "Award__toolbar-1orlf";
export var wrapper = "Award__wrapper-uqjmh";